/**
 * The support chat is a Zoho SalesIQ widget, loaded by the script tags in
 * `index.html`. Its own floating launcher is hidden there (it sat on top of
 * the bottom-right action buttons, YC-34); the sidebar's "Contact" item opens
 * the chat window instead.
 */

interface SalesIQ {
  floatwindow?: { visible?: (state: "show" | "hide") => void };
}

declare global {
  interface Window {
    $zoho?: { salesiq?: SalesIQ };
  }
}

/** Opens the chat window. Returns false when the widget has not loaded. */
export function openSupportChat(): boolean {
  const show = window.$zoho?.salesiq?.floatwindow?.visible;
  if (typeof show !== "function") return false;
  show("show");
  return true;
}
